'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _icon = require('antd/lib/icon');

var _icon2 = _interopRequireDefault(_icon);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _tooltip = require('antd/lib/tooltip');

var _tooltip2 = _interopRequireDefault(_tooltip);

var _connectField = require('uniforms/connectField');

var _connectField2 = _interopRequireDefault(_connectField);

var _filterDOMProps = require('uniforms/filterDOMProps');

var _filterDOMProps2 = _interopRequireDefault(_filterDOMProps);

var _joinName = require('uniforms/joinName');

var _joinName2 = _interopRequireDefault(_joinName);

var _ListAddField = require('./ListAddField');

var _ListAddField2 = _interopRequireDefault(_ListAddField);

var _ListItemField = require('./ListItemField');

var _ListItemField2 = _interopRequireDefault(_ListItemField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var List = function List(_ref) {
    var children = _ref.children,
        error = _ref.error,
        errorMessage = _ref.errorMessage,
        info = _ref.info,
        initialCount = _ref.initialCount,
        itemProps = _ref.itemProps,
        label = _ref.label,
        labelCol = _ref.labelCol,
        name = _ref.name,
        showInlineError = _ref.showInlineError,
        value = _ref.value,
        wrapperCol = _ref.wrapperCol,
        props = (0, _objectWithoutProperties3.default)(_ref, ['children', 'error', 'errorMessage', 'info', 'initialCount', 'itemProps', 'label', 'labelCol', 'name', 'showInlineError', 'value', 'wrapperCol']);
    return _react2.default.createElement(
        'div',
        (0, _filterDOMProps2.default)(props),
        !!label && _react2.default.createElement(
            'div',
            null,
            label,
            !!info && _react2.default.createElement(
                'span',
                null,
                '\xA0',
                _react2.default.createElement(
                    _tooltip2.default,
                    { title: info },
                    _react2.default.createElement(_icon2.default, { type: 'question-circle-o' })
                )
            )
        ),
        !!(error && showInlineError) && _react2.default.createElement(
            'div',
            null,
            errorMessage
        ),
        children ? value.map(function (item, index) {
            return _react.Children.map(children, function (child) {
                return _react2.default.cloneElement(child, {
                    key: index,
                    label: null,
                    name: (0, _joinName2.default)(name, child.props.name && child.props.name.replace('$', index))
                });
            });
        }) : value.map(function (item, index) {
            return _react2.default.createElement(_ListItemField2.default, (0, _extends3.default)({
                key: index,
                label: null,
                labelCol: labelCol,
                name: (0, _joinName2.default)(name, index),
                wrapperCol: wrapperCol
            }, itemProps));
        }),
        _react2.default.createElement(_ListAddField2.default, { name: name + '.$', initialCount: initialCount })
    );
};

List.defaultProps = {
    style: {
        border: '1px solid #DDD',
        borderRadius: '7px',
        marginBottom: '5px',
        marginTop: '5px',
        padding: '10px'
    }
};

exports.default = (0, _connectField2.default)(List, { ensureValue: true, includeInChain: false });


//////////////////
// WEBPACK FOOTER
// ./~/uniforms-antd/ListField.js
// module id = 286
// module chunks = 35783957827783 65974612472484